import Button from '../../elements/buttons/Button';

export const Dispositivo = ({
    className,
    classNameBox,
    brand,
    title,
    copy,
    link,
    image
}) => {
  return (
    <>
        <article className={`dispositivo ${className}`}>
            <div className="dispositivo__col">
                <div className={`dispositivo-brand ${classNameBox}`}>
                    <img src={brand}/>
                </div>
                <figure>
                    <img src={image} className="dispositivo-image" />
                </figure>
            </div>
            <div className="dispositivo__col second">
                <div className={`dispositivo-brand ${classNameBox}`}>
                    <img src={brand}/>
                </div>
                <h3 className="titles dispositivo_title">{title}</h3>
                <p>{copy}</p>
                <Button copy="Consíguelo ahora" link={link} target="blank" className="button-primary button-icon-white" />
            </div>
        </article>

    </>
  );
};